var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"itemData":_vm.itemData,"utilityList":_vm.utilityList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }